import { Wrapper, ErrorMsg, Label } from './validation-alert-wrapper.styled';

interface IValidationInputProps {
  children: any;
  label?: string;
  placeholder?: string;
  errorMsg: string | null;
  invalid: boolean;
  className?: string;
  shadowOnlyFor?: string;
}

export const ValidationAlertWrapper = ({
  children,
  label,
  errorMsg,
  invalid,
  className,
  shadowOnlyFor,
}: IValidationInputProps) => {
  return (
    <Wrapper
      invalid={invalid}
      {...(className && { className })}
      shadowOnlyFor={shadowOnlyFor}
    >
      {label && <Label>{label}</Label>}
      {children}
      {invalid && <ErrorMsg>{errorMsg}</ErrorMsg>}
    </Wrapper>
  );
};
